import React from "react";
import { motion } from "framer-motion";
// import background from "../../images/home/Rohan-video-thumbnail.jpg";
import * as styles from "./styles.module.css";

/**
 * Extract the ID from the @field_numbered_slider_video
 * and use it to embed the Iframe
 * Format should be like: https://youtu.be/.....
 */
function getId(id) {
  const trimmedId = id.replace("https://youtu.be/", "").split("?si=");
  const extractedId = trimmedId[0].trim();
  return extractedId;
}
function getVimId(id) {
  const trimmedVimId = id.replace("https://vimeo.com/", "").split("?h=");
  const extractedVimId = trimmedVimId[0];
  return extractedVimId;
}

var loadInfo = function (videoId) {
  var gdata = document.createElement("script");
  gdata.src =
    "http://gdata.youtube.com/feeds/api/videos/" +
    videoId +
    "?v=2&alt=jsonc&callback=storeInfo";
  var body = document.getElementsByTagName("body")[0];
  body.appendChild(gdata);
};

// var storeInfo = function (info) {
//   console.log(info.data.title);
// };

const Video = ({ featuredVideo, storyPosition, storyTitle, thumbnail }) => {
  const videoLink = featuredVideo;
  const background = thumbnail;
  const position = storyPosition;
  const title = storyTitle;

  const [play, setPlay] = React.useState(false);

  const url = play
    ? `${getId(featuredVideo)}?autoplay=1`
    : `${getId(featuredVideo)}`;

  return (
    <motion.div
      // initial={{ boxShadow: `#b04027 0 0 0` }}
      // whileInView={{ boxShadow: `#b04027 20px 20px 0` }}
      viewport={{ once: true }}
      transition={{ delay: 0.75 }}
      style={{
        // border: `7px solid #b04027`,
        // backgroundColor: "#b04027",
        position: "relative",
        marginBottom: "0px",
        overflow: "hidden",
      }}
    >
      <motion.div
        initial={{ x: "100%" }}
        whileInView={{ x: "0%" }}
        viewport={{ once: true }}
        transition={{
          delay: 0.2,
          duration: 0.4,
        }}
        style={{ position: "relative" }}
      >
        {videoLink.includes("youtu.be/") ? (
          <div
            className={styles.backgroundDiv}
            style={{
              backgroundImage: `url(${background})`,
            }}
          >
            <div className={styles.buttonDiv}>
              {!play && (
                <button
                  onClick={() => setPlay(!play)}
                  className={styles.buttonPlay}
                  aria-label="Play video"
                  data-story-number={position}
                  data-story-title={title}
                  iframe-url={`https://www.youtube.com/embed/${url}`}
                ></button>
              )}
            </div>
            <iframe
              className={!play ? styles.iframeToggle : ""}
              loading="lazy"
              src={`https://www.youtube.com/embed/${url}`}
              title={loadInfo(featuredVideo)}
              allow="accelerometer; autoplay; encrypted-media; modestbranidng; gyroscope; picture-in-picture"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              width="540"
              height="300"
            />
          </div>
        ) : (
          <iframe
            src={`https://player.vimeo.com/video/${getVimId(
              featuredVideo
            )}?byline=0&portrait=0`}
            title={featuredVideo.name}
            width="100%"
            height="300"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
          ></iframe>
        )}
      </motion.div>
    </motion.div>
  );
};
export default Video;
